import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Typography} from '~library/atoms/Typography';
import {UPDATE_DESIGN_OPTIONS} from '~/CreateFabricInvitation/reducers/fabricDesign/constants';
import {selectIsPristineUyoByFindingId} from '~/CreateFabricInvitation/reducers/fabricDesign/selectors';
import {
  INACTIVE_OBJECT_TEXT,
  DEFAULT_INSTRUCTION_TEXT,
  DYO_INSTRUCTION_TEXT,
} from '~/common/fabric/constants';

export const Instructions = () => {
  const dispatch = useDispatch();
  const activeObject = window.canvas?.getActiveObject();
  const isFullDyo = useSelector(
    ({fabricTemplate}) =>
      fabricTemplate.templateName.includes('general-full') &&
      fabricTemplate.templateName.includes('dyo')
  );

  const isPristineUyoByFindingId = useSelector(selectIsPristineUyoByFindingId);

  useEffect(() => {
    if (activeObject) {
      dispatch({type: UPDATE_DESIGN_OPTIONS, payload: {touched: true}});
    }

    return () => {
      dispatch({
        type: UPDATE_DESIGN_OPTIONS,
        payload: {textAreaOpen: false},
      });
    };
  }, [activeObject]);

  let instructionText = DEFAULT_INSTRUCTION_TEXT;

  if (isPristineUyoByFindingId) {
    instructionText = DEFAULT_INSTRUCTION_TEXT;
  } else if (activeObject === null) {
    // NOTE: when 'activeObject' is null, it means that the user has previously select on an object
    instructionText = INACTIVE_OBJECT_TEXT;
  } else if (isFullDyo) {
    instructionText = DYO_INSTRUCTION_TEXT;
  }

  return (
    <div className="welcome-instructions-container">
      <div className="edit_box welcome-instructions">
        <img
          className="welcome-instructions-img"
          src="/assets/images/step-1-instructions-img.png"
          alt=""
        />
        <Typography as="p" variant="paragraph2" size="medium" color="pebble">
          {instructionText}
        </Typography>
      </div>
    </div>
  );
};
